exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  text-align: center;\n}\n\n.images {\n  list-style: none;\n}\n\n.imageClass {\n  width: 250px;\n  margin-bottom: 5px;\n  height: 300px;\n}", ""]);

// exports
